/**
 * @generated SignedSource<<310370afe0504c28c575390927698171>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OpportunitiesListQuery$variables = {
  isPublicInternet?: boolean | null | undefined;
};
export type OpportunitiesListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OpportunitiesList_query">;
};
export type OpportunitiesListQuery = {
  response: OpportunitiesListQuery$data;
  variables: OpportunitiesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isPublicInternet"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "isPublicInternet",
    "variableName": "isPublicInternet"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpportunitiesListQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "OpportunitiesList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpportunitiesListQuery",
    "selections": [
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "JobPostingConnection",
            "kind": "LinkedField",
            "name": "jobPostings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JobPostingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobPosting",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "122c91281daf5ee59487c72ca2cc9d06",
    "id": null,
    "metadata": {},
    "name": "OpportunitiesListQuery",
    "operationKind": "query",
    "text": "query OpportunitiesListQuery(\n  $isPublicInternet: Boolean\n) {\n  ...OpportunitiesList_query_3YPYAn\n}\n\nfragment OpportunitiesCard_jobPosting on JobPosting {\n  id\n  title\n}\n\nfragment OpportunitiesList_query_3YPYAn on Query {\n  company: companyDomainName {\n    jobPostings(isPublicInternet: $isPublicInternet) {\n      edges {\n        node {\n          id\n          ...OpportunitiesCard_jobPosting\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6c25a489d4b4cdb7ba80ebdc74d0ea2";

export default node;
